import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {
	DATAPOINT_DESIRED_JOBS_JOB_ID,
	DATAPOINT_REPORTED_JOBS_JOB_ID,
	DATAPOINT_REPORTED_JOBS_BUNDLE_ID,
	DATAPOINT_REPORTED_JOBS_VERSION_ID,
	DATAPOINT_REPORTED_JOBS_SEQUENCE_NUMBER,
	DATAPOINT_REPORTED_JOBS_UPDATE_STATUS
} from '../../../../../modules/common/consts';
import type {AssetInfoData} from '../types';
import {InfoType} from '../types';
import {AssetInfoBlockWrapper} from '../AssetInfoBlock';
import LabelValueField from '../LabelValueField';
import DataPointInfo from '../DataPointInfo';
import BundleLink from '../../../../../components/common/BundleLink';
import BundleVersionLink from '../../../../../components/common/BundleVersionLink';
type Props = {
	assetData: AssetInfoData;
};
const bundleIdLabel = {
	i18nKey: `rafi.datapoints.${DATAPOINT_REPORTED_JOBS_BUNDLE_ID}`,
	defaultValue: 'Bundle Id'
};
const versionIdLabel = {
	i18nKey: `rafi.datapoints.${DATAPOINT_REPORTED_JOBS_VERSION_ID}`,
	defaultValue: 'Bundle Version Id'
};

const FirmwareAssetInfo = ({assetData}: Props) => {
	const bundleId = assetData[DATAPOINT_REPORTED_JOBS_BUNDLE_ID];
	const versionId = assetData[DATAPOINT_REPORTED_JOBS_VERSION_ID];
	const desiredFW = assetData[DATAPOINT_DESIRED_JOBS_JOB_ID];
	const reportedFW = assetData[DATAPOINT_REPORTED_JOBS_JOB_ID];
	const isSynced = (desiredFW && desiredFW.value) === (reportedFW && reportedFW.value);
	const currentSyncState = isSynced ? 'synchronised' : desiredFW ? 'unsynchronised' : 'unknown';
	return (
		<AssetInfoBlockWrapper type={InfoType.FIRMWARE}>
			<h2 className="properties">
				<Trans i18nKey="rafi.info.desiredProperties">Desired Properties</Trans>
			</h2>
			<DataPointInfo
				className={currentSyncState}
				dataPointName={DATAPOINT_DESIRED_JOBS_JOB_ID}
				dataPointInfo={assetData[`${DATAPOINT_DESIRED_JOBS_JOB_ID}`]}
			/>
			<h2 className="properties">
				<Trans i18nKey="rafi.info.reportedProperties">Reported Properties</Trans>
			</h2>
			<DataPointInfo
				className={currentSyncState}
				dataPointName={DATAPOINT_REPORTED_JOBS_JOB_ID}
				dataPointInfo={assetData[`${DATAPOINT_REPORTED_JOBS_JOB_ID}`]}
			/>
			<LabelValueField label={bundleIdLabel}>
				<BundleLink bundleId={(bundleId && bundleId.value) || ''}>
					{bundleId ? bundleId.value : '--'}
				</BundleLink>
			</LabelValueField>
			<LabelValueField label={versionIdLabel}>
				<BundleVersionLink
					bundleId={(bundleId && bundleId.value) || ''}
					versionId={(versionId && versionId.value) || ''}>
					{versionId ? versionId.value : '--'}
				</BundleVersionLink>
			</LabelValueField>
			<DataPointInfo
				dataPointName={DATAPOINT_REPORTED_JOBS_UPDATE_STATUS}
				dataPointInfo={assetData[`${DATAPOINT_REPORTED_JOBS_UPDATE_STATUS}`]}
			/>
			<DataPointInfo
				dataPointName={DATAPOINT_REPORTED_JOBS_SEQUENCE_NUMBER}
				dataPointInfo={assetData[`${DATAPOINT_REPORTED_JOBS_SEQUENCE_NUMBER}`]}
			/>
		</AssetInfoBlockWrapper>
	);
};

export default FirmwareAssetInfo;
